import $ from 'jquery';
import Helpers from '../helpers/util';
import DragDrop from './dragdrop';

const trackPersonalisationSave = type => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: `custom.event.${type}_save`,
		'custom.event.sidebar_name': type
	});
};

const trackPersonalisationOpen = type => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: `custom.event.${type}_open`,
		'custom.event.sidebar_name': type
	});
};

class Personalisation {
	constructor(el) {
		// Elements
		this.$el = $(el);
		this.selectors = {
			section: '.personalisation__section',
			displaySection: '.personalisation__section--display',
			otherSection: '.personalisation__section--other',
			innerCont: '.personalisation__inner',
			saveButton: '.personalisation__save',
			cancelButton: '.personalisation__cancel',
			dragDropItem: '.dragdrop__item',
			dragDropCont: '.dragdrop'
		};

		this.classes = {
			otherSection: 'personalisation__section--display'
		};

		this.$otherList = this.$el
			.find(this.selectors.otherSection)
			.find(this.selectors.innerCont);
		this.$displayList = this.$el
			.find(this.selectors.displaySection)
			.find(this.selectors.innerCont);

		this.nrToDisplay = 5;
		this.type = this.$el.data('type');

		this.getAllItems();
		this.attachEvents();
	}

	getAllItems() {
		// const APIBASEURL = `/data/${this.type}.json`;
		const localAPI = `/data/${this.type}.json`;
		const productionAPI = `/api/${this.type}`;
		const APIBASEURL = Helpers.urlExists(productionAPI)
			? productionAPI
			: localAPI;

		fetch(APIBASEURL)
			.then(res => res.json())
			.then(data => {
				this.data = data;

				this.createLists();
				this.activateDragDrop();
			});
	}

	createItem(item, index) {
		const _temp = `<div class="dragdrop__item" data-index="${index}" data-id="${
			item.id
		}">
            <div class="item-content">
                <span class="order">${index}</span> ${item.title}
                <span class="icon icon-drag"></span>
            </div>
        </div>`;

		return _temp;
	}

	activateDragDrop() {
		if (this.$el.find(this.selectors.dragDropItem).length) {
			this.drag = new DragDrop(this.$el.get(0));
		}
	}

	createItemList(arrayList, ctx) {
		const dragDropElement = '<div class="dragdrop js-dragdrop"></div>';
		const $section = $(ctx);

		$.when($section.append(dragDropElement)).then(() => {
			arrayList.forEach((item, index) => {
				let itemList = this.createItem(item, index);

				$section.find(this.selectors.dragDropCont).append(itemList);
			});
		});
	}

	createLists() {
		this.$el.find(this.selectors.section).each((i, el) => {
			const isDisplaySection = $(el).hasClass(this.classes.otherSection);

			const arrayToDisplay = isDisplaySection
				? this.data.slice(0, this.nrToDisplay)
				: this.data.slice(this.nrToDisplay);

			const ctx = isDisplaySection ? this.$displayList : this.$otherList;

			this.createItemList(arrayToDisplay, ctx);
		});

		if (this.data.length < this.nrToDisplay) {
			this.$otherList.html(
				'<span class="info">No other items available</span>'
			);
		}
	}

	getListItemId() {
		const containers = this.drag.getContaners();

		const arrayItems = containers
			.map(cont => cont.sortables)
			.reduce((a, b) => a.concat(b), []);

		const arrayIds = arrayItems.map(item =>
			item.element.getAttribute('data-id')
		);

		return arrayIds;
	}

	sendListPersonalised() {
		return new Promise(resolve => {
			const arrayIds = this.getListItemId();

			// Fetch token
			fetch('/session/token')
				.then(res => res.text())
				.then(data => {
					this.token = data;

					$.ajax({
						url: `/api/${this.type}/save`,
						data: JSON.stringify(arrayIds),
						type: 'POST',
						dataType: 'json',
						contentType: 'application/json',
						headers: {
							'X-CSRF-Token': this.token
						},
						success: () => {
							resolve();
						},
						error: () => {
							// console.log('Error');
							resolve();
						}
					});
				});
		});
	}

	attachEvents() {
		let $save = this.$el.find(this.selectors.saveButton);
		$save.on('click', () => {
			trackPersonalisationSave(this.type);

			this.sendListPersonalised().then(() => {
				Helpers.pubsub.publish('closeSidebar');
				window.location.reload();
			});
		});

		let $cancel = this.$el.find(this.selectors.cancelButton);
		$cancel.on('click', () => {
			Helpers.pubsub.publish('closeSidebar');
		});
	}
}

const _init = () => {
	// Elements
	let $els = $('.personalisation');
	if ($els.length) {
		$els.each((i, el) => {
			new Personalisation(el);
		});
	}

	Helpers.pubsub.subscribe('onSidebarShow', (name, e) => {
		const dataSidebar = e.data('sidebar');
		if (dataSidebar && dataSidebar === 'vaccines') {
			trackPersonalisationOpen(dataSidebar);
		}
	});
};

_init();
